
export enum FilterType {
  TextBox = 1,
  DropdownList = 2,
  AutocompleteTextBox = 3,
  DatePicker = 4,
  TagInput = 5,
  CheckBox = 6,
  Other=7
}